/* eslint-disable no-undef */
/* eslint no-param-reassign: "off" */

export default {
  install(Vue, options) {
    Vue.prototype.$content = {
      getActual() {
        const { points } = options.store.state.data;
        let { point } = options.store.state.data;
        if (point === 'null') point = null;
        if (!!point || point === 0) {
          if (points[point]) {
            return points[point].catalogues || [];
          }
          return [];
        }
        let out = [];
        points.forEach((pointData) => { out = [...out, ...(pointData.catalogues || [])]; });
        return out;
      },
      extractSections2(items) {
        const { settings } = options.store.state.data;
        // if (item.root && settings.disable_navigation_menu) {
        //  return [];
        // }
        if (settings.disable_navigation_inner || !Array.isArray(items)) {
          return [];
        }
        return items.filter(({ dir, children }) => dir && children && children.length);
      },
      extractProducts2(items) {
        return items.filter(({ dir }) => !dir);
      },
      flatten2(items, item, menu, depth) {
        let out = [];
        const { children, dir, root } = item;
        if (!children || (!dir && !root)) return [];
        const childrenData = children.map((id) => items.find(({ _id }) => _id === id));
        for (let i = 0; i < childrenData.length; i++) {
          const child = childrenData[i];
          if (child.dir) {
            const data = child.children.map((id) => items.find(({ _id }) => _id === id));
            out.push({ ...child,
              name: child.dirLabel,
              menu,
              depth,
              sections: this.extractSections2(data),
              content: this.extractProducts2(data)
            });
            out = [...out, ...this.flatten2(items, child, menu, depth + 1)];
          }
        }
        return out;
      },
      getFlattened() {
        console.log('getFlattened');
        const catalogues = this.getActual();
        let out = [];
        catalogues.forEach((catalogue) => {
          const rootItem = catalogue.content.find(({ root }) => root);
          out = [...out, ...this.flatten2(catalogue.content, rootItem, catalogue._id, 0)];
        });
        return out;
      }
    };
  }
};
